<form [formGroup]="userForm" fxLayout="column">
  <div class="mat-error  mb-3" *ngIf="generalError">
    {{ generalError?.message }}
  </div>

  <mat-form-field>
    <mat-label>Email</mat-label>
    <input formControlName="email" matInput type="email" name="email">
    <mat-error *ngIf="userForm.controls.email?.errors?.pattern && !userForm.controls.email?.errors?.required">
      Please enter a valid email address
    </mat-error>
    <mat-error *ngIf="userForm.controls.email?.errors?.required">
      Field <strong>required</strong>
    </mat-error>
  </mat-form-field>

  <mat-form-field>
    <mat-label>First name</mat-label>
    <input formControlName="firstName" matInput type="text" name="firstname">
    <mat-error *ngIf="userForm.controls.firstName?.errors?.required">
      Field <strong>required</strong>
    </mat-error>
  </mat-form-field>

  <mat-form-field>
    <mat-label>Last name</mat-label>
    <input formControlName="lastName" matInput type="text" name="lastname">
    <mat-error *ngIf="userForm.controls.lastName?.errors?.required">
      Field <strong>required</strong>
    </mat-error>
  </mat-form-field>

  <mat-form-field>
    <mat-label>Phone</mat-label>
    <input formControlName="phone" matInput type="tel" name="phone" [mask]="'+00 000 0*'"
           [dropSpecialCharacters]="false">
    <mat-error *ngIf="userForm.controls.phone?.errors?.pattern && !userForm.controls.phone?.errors?.required">
      Please enter a valid phone number
    </mat-error>
    <mat-error *ngIf="userForm.controls.phone?.errors?.required">
      Field <strong>required</strong>
    </mat-error>

  </mat-form-field>

  <!--region Company field -->
  <ng-container *ngIf="this._user.company && userForm.contains('company')">
    <ng-container *awIsInAnyRole="['admin']">
      <mat-form-field>
        <mat-label>Company</mat-label>
        <mat-select formControlName="company" name="company" [compareWith]="compareCompany" [disabled]="isEditing">
          <mat-option *ngFor="let company of companies" [value]="company" >
            {{ company.companyName }}
          </mat-option>
        </mat-select>
        <span matPrefix *ngIf="loadingCompanies"><i class="fas fa-spinner fa-spin color-primary"></i>&nbsp;</span>
        <mat-error *ngIf="userForm.controls.company?.errors?.required">
          Field <strong>required</strong>
        </mat-error>
        <mat-hint *ngIf="!loadingCompanies && companies.length === 0" class="color-warn">
          No companies available.
        </mat-hint>
      </mat-form-field>
    </ng-container>
  </ng-container>
  <!--endregion -->

  <!--region Researcher fields -->
  <div fxLayout="column" fxLayoutGap="10px" *ngIf="userForm.contains('address')">
    <mat-form-field fxFlex="45">
      <mat-label>Address</mat-label>
      <input
        formControlName="address"
        matInput
        type="text">
      <mat-error *ngIf="userForm.controls.address?.errors?.required">
        Field <strong>required</strong>
      </mat-error>
    </mat-form-field>


    <mat-form-field fxFlex="45">
      <mat-label>MAC Address</mat-label>
      <input formControlName="macAddress" matInput type="text">
      <mat-error *ngIf="userForm.controls.macAddress?.errors?.required">
        Field <strong>required</strong>
      </mat-error>
      <mat-error *ngIf="userForm.controls.macAddress?.errors?.pattern">
        Enter a valid MAC address
      </mat-error>
    </mat-form-field>

    <mat-form-field fxFlex="45">
      <mat-label>Operating System</mat-label>
      <input formControlName="operatingSystem" matInput type="text">
      <mat-error *ngIf="userForm.controls.operatingSystem?.errors?.required">
        Field <strong>required</strong>
      </mat-error>
    </mat-form-field>

    <mat-form-field fxFlex="45">
      <mat-label>Organization Name</mat-label>
      <input formControlName="organizationName" matInput type="text">
      <mat-error *ngIf="userForm.controls.organizationName?.errors?.required">
        Field <strong>required</strong>
      </mat-error>
    </mat-form-field>
  </div>

  <!-- endregion -->

  <!--region toggle fields buttons -->
  <ng-container>
    <div class="mt-2_5">
      <ng-container *ngIf="isAdmin">
        <button mat-stroked-button color="primary" (click)="addCompanyField()"
          *ngIf="!userForm.contains('company') && this._user.company == null && !userForm.contains('address')">
            Add Company Field
        </button>
      </ng-container>
    </div>

    <div *ngIf="userForm.contains('company') && isAdmin">
      <button mat-stroked-button color="warn" (click)="removeCompanyField()">
        Remove Company Field
      </button>
    </div>

    <div class="mt-2_5">
      <button mat-stroked-button color="primary" (click)="addResearcherFields()"
              *ngIf="!userForm.contains('address') && !userForm.contains('company')">
        Add Researcher Fields
      </button>
    </div>

    <div *ngIf="userForm.contains('address')" class="mt-2">
      <button mat-stroked-button color="warn" (click)="removeResearcherFields()">
        Remove Researcher Fields
      </button>
    </div>
  </ng-container>
  <ng-container *ngIf="!isEditing">
  <mat-label class="mt-2 permissions-label">Permissions: </mat-label>

  <mat-hint *ngIf="!loadingPermissions && permissions.length === 0" class="color-warn">
    No permissions available.
  </mat-hint>

  <mat-action-list>
    <mat-list-item *ngFor="let permission of permissions"
                   (click)="!isPermissionDisabled(permission.name) && togglePermission(permission.name)"
                   [class.disabled-item]="isPermissionDisabled(permission.name)">
      <div matListItemIcon>
        <mat-spinner mode="indeterminate" diameter="20" *ngIf="loadingPermissions"></mat-spinner>
        <ng-container *ngIf="!loadingPermissions">
          <mat-icon *ngIf="selectedPermissionNames.includes(permission.name)" color="primary">check_box</mat-icon>
          <mat-icon *ngIf="!selectedPermissionNames.includes(permission.name) && !isPermissionDisabled(permission.name)" color="accent">check_box_outline_blank</mat-icon>
          <mat-icon *ngIf="!selectedPermissionNames.includes(permission.name) && isPermissionDisabled(permission.name)" color="accent" class="disabled-icon">check_box_outline_blank</mat-icon>
        </ng-container>
      </div>
      <div matListItemTitle class="uppercase">{{ permission.name }}</div>
    </mat-list-item>
  </mat-action-list>
</ng-container>
  <!-- endregion -->




  <div fxLayout="row" fxLayoutAlign="end">
    <button (click)="onCancel()" mat-button>Cancel</button>
    <button (click)="saveUser()" [disabled]="userForm.invalid || saving " color="primary" mat-button>
      <i *ngIf="saving" class="fas fa-spinner fa-spin"></i>
      <ng-container *ngIf="!saving">Save</ng-container>
    </button>
  </div>


  <!--endregion -->

</form>
